import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';

@Component({
    selector: 'tri-state-toggle',
    templateUrl: './tri-state-toggle.component.html',
    styleUrls: ['./tri-state-toggle.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TriStateToggleComponent),
            multi: true,
        },
    ],
    imports: [MatButtonToggleGroup, MatButtonToggle]
})
export class TriStateToggleComponent implements ControlValueAccessor {
  @Input() labelUnset = 'Unset';
  @Input() labelTrue = 'True';
  @Input() labelFalse = 'False';

  value: boolean | null = null;
  disabled = false;

  onChange = (value: boolean | null) => {};
  onTouched = () => {};

  setValue(val: boolean | null) {
    this.value = val;
    this.onChange(val);
    this.onTouched();
  }

  writeValue(val: boolean | null): void {
    this.value = val;
  }
  registerOnChange(fn: (value: boolean | null) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
